export default __webpack_public_path__ + "c6fb152bdfcf7ac98e072355e2f68142.svg";